import { Theme, themeQuartz } from 'ag-grid-community';

export const agGridDarkTheme: Theme = themeQuartz.withParams({
  backgroundColor: 'rgb(24,29,31)',
  foregroundColor: 'rgb(255,255,255)',
  accentColor: 'rgb(51,124,148)',
  headerTextColor: 'rgb(255,255,255)',
  headerBackgroundColor: 'rgb(34,38,40)',
  // Bumped from rgb(34,38,40) — the previous value was only ~10 RGB units
  // brighter than the base background, so the zebra striping was invisible
  // against the surrounding dark card and a single-row grid looked unbounded.
  oddRowBackgroundColor: 'rgb(45,51,54)',
  headerColumnResizeHandleColor: 'rgb(61,62,61)',
  browserColorScheme: 'dark',
});
